import React from 'react';

import PropTypes from 'prop-types';
import {
  Container,
  Title,
  Content,
  ContentLineTitle,
  SliderContainer,
} from './styles';

import Slider from '~/components/Section03Slider';

import ArrowDown from '~/components/ArrowDown';

export default function Section03({ id }) {
  return (
    <Container id={id}>
      <Title>
        Conheça os <span>Projetos</span>
      </Title>
      <Content>
        {/* <Vector /> */}
        <ContentLineTitle>
          <h3>
            Projeto para <span>Crianças e Adolescentes</span>
            </h3>
        </ContentLineTitle>
        <SliderContainer>
          <Slider lineTo="children" />
        </SliderContainer>        
        <ContentLineTitle>
          <h3>
            Projetos para <span>Pessoas Idosas</span>            
          </h3>
	  {/*<div class='col-sm-8 mb-5'>
      <h4>Os projetos para população idosa estão em desenvolvimento pela FUNDASP/PUC-SP para apresentação em EDITAL do Fundo do Idoso previsto para este ano.</h4>
      <h4>Os recursos destinados serão disponibilizados e utilizados neste próximo Edital.</h4>
      </div>*/}
        </ContentLineTitle>
        {/*<SliderContainer>
          <Slider lineTo="oldies" />
        </SliderContainer>*/} 
	  <SliderContainer>
          <Slider lineTo="oldies" />
        </SliderContainer>
      </Content>

      <ArrowDown toElement="passoapasso" className="ArrowDown" />
    </Container>
  );
}
Section03.propTypes = {
  id: PropTypes.string,
};
